export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 max-w-5xl mx-auto bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="flex-1 px-6 md:px-10 py-10 md:py-14 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-background-50">
              手机随时看，好片不错过
            </h2>
            <p className="mt-3 text-sm md:text-base text-primary-100 leading-relaxed">
              91电影移动端适配完美，无论你在通勤路上还是午休间隙，打开手机就能浏览最新国产电影推荐，随时随地发现好片。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#cards');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-700 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line"></i>
                立即体验
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 px-6 md:px-0 pb-8 lg:pb-0 lg:pr-10">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20Chinese%20movie%20app%20interface%2C%20film%20poster%20thumbnails%20on%20mobile%2C%20warm%20cinematic%20color%20scheme%20with%20red%20and%20gold%20accents%2C%20modern%20mobile%20UI%20design%2C%20clean%20dark%20mode%20layout%2C%20movie%20streaming%20app%20mockup%20on%20phone%20screen&width=800&height=700&seq=app-movie-2026&orientation=portrait"
              alt="91电影移动端体验"
              className="w-48 md:w-56 h-auto rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}